import type { OverviewViewProps } from "./types-overview-view";
import { useOverviewView } from "./use-overview-view";
import { OverviewViewView } from "./view-overview-view";

export function OverviewView(props: OverviewViewProps) {
  const vm = useOverviewView(props);

  return <OverviewViewView {...vm} />;
}

export type * from "./types-overview-view";
